export const getHeightEl = (id) => { 
  const el = document.getElementById(id);
  if (!el) return 0;
  return el.getBoundingClientRect().height;
}
